import React, { Component } from 'react';
import { Table, Divider, Button, Icon, Popconfirm} from 'antd';
import axios from 'axios';
import LicenseDialogForm from './LicenseForm'
import { connect } from 'react-redux';

const API_HOST_URL = process.env.REACT_APP_API_URL

class License extends Component{
  
  state = {
    datalist: [],
    license: {},
    visible: false,
    requestType: ''
  }

  componentDidMount(){
    this.fetchData();
  }

  columns = [
    {
      title: 'License',
      dataIndex: 'license',
      key: 'license'
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (record) => (
        <span>
        <a href="javascript:;" onClick={() => this.handleEdit(record)}><Icon type="edit" /></a>

        <Divider type="vertical" />

        {this.state.datalist.length >= 1
          ? (
            <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record)}>
              <a href="javascript:;"><Icon type="delete" /></a>
            </Popconfirm>
          ) : null}
          </span>
      ),

    }
  ];

  fetchData = () => {
    axios.get(`${API_HOST_URL}/api/systemsetup/license/`)
      .then(res => {
        this.setState({
          datalist: res.data
        })
      })
  }

  handleCreate = () => {
    const form = this.formRef.props.form;
    const requestType = this.state.requestType;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      switch( requestType ){
        case 'post':
            return axios.post(`${API_HOST_URL}/api/systemsetup/license/`, {
              license: values.license
            })
            .then(res => {
              console.log(res)
              form.resetFields();
              this.setState({ visible: false });
              this.fetchData()
        })
            .catch(error => console.err(error));

        case 'put':
            return axios.put(`${API_HOST_URL}/api/systemsetup/license/${this.state.license.id}/`, {
             license: values.license
            })
                .then(res => {
                  console.log(res)
                  form.resetFields();
                  this.setState({ visible: false });
                  this.fetchData()
            })
                .catch(error => console.err(error));
                
        default: return;
      }
    });
  }

  handleEdit = record => {
      this.setState({license: record});
      this.showModal('put');
  }

  handleDelete = (record) => {
    const datalist = [...this.state.datalist];

    return axios.delete(`${API_HOST_URL}/api/systemsetup/license/${record.id}/`)
                .then(res => {
                  console.log(res)

                  this.setState({ visible: false });
                  this.fetchData()
            })
                .catch(error => console.err(error));
  }

  showModal = (type) => {
    if( type === 'post'){
      //no data should be passed to dialog form
      this.setState({license: {}});
    }

    this.setState({ visible: true, requestType: type });
  }

  handleCancel = () => {
    this.setState({ visible: false });
  }

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  }

    render(){
        return(
          <div>
            {
              this.props.userPermissions.indexOf('add_license') > -1 ?
              <Button type="primary" onClick={() => this.showModal('post')}>Add License</Button>
              : ''
            }

            {
              this.props.userPermissions.indexOf('view_license') > -1 ?
              <Table columns={this.columns} dataSource={this.state.datalist} rowKey="id"/>
              : 'You do not have rights to view Licenses. Please Contact your Administrator'
            }

            <LicenseDialogForm
              wrappedComponentRef={this.saveFormRef}
              visible={this.state.visible}
              onCancel={this.handleCancel}
              onCreate={this.handleCreate}
              data={this.state.license}/>
        </div>
        );
    }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null,
    userPermissions: state.userPermissions
  }
}

export default connect(mapStateToProps, null)(License);
// export default License;
